import { render } from "./LockMember.vue?vue&type=template&id=2a142c65&scoped=true"
import script from "./LockMember.vue?vue&type=script&lang=js"
export * from "./LockMember.vue?vue&type=script&lang=js"

import "./LockMember.vue?vue&type=style&index=0&id=2a142c65&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a142c65"]])

export default __exports__